module.exports = __webpack_public_path__ + "img/遺言書草案_SP.bbcea638.png";